export const BREAKPOINTS = {
  mobile: 375,
  tablet: 768,
  laptop: 1280,
  desktop: 1920,
};

export const CONTAINER_WIDTHS = {
  mobile: 343,
  tablet: 720,
  laptop: 1219,
  desktop: 1416,
};

export const COLORS = {
  white: "#FFFFFF",
  black: "#0C0C0E",

  violet: "#4A25D5",
  darkViolet: "#3F1BC8",
  lightViolet: "#E4DEF9",
  lightestViolet: "#F6F4FD",

  green: "#B7E801",
  lightGreen: "#C4F900",
  lightestGreen: "#F4FCDD",

  red: "#D52566",
  darkRed: "#C61858",
  lightRed: "#FBE4ED",

  grey: "#43474A",
  lightGrey: "#AEAEAE",
  lightestGrey: "#F5F5F5",
};
